<script lang="ts">
	import type { WayPoint } from '$lib/components/search/itinerary/types';
	import type { Coordinates, LineString } from '../types';
	import { browser } from '$app/environment';
	import { getWaypointCoordinates } from '$lib/components/search/itinerary/ItineraryStore';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';
	import { filterUndefined } from '$lib/utils/predicates';
	import { watch } from 'runed';
	import { GeoJSON, LineLayer } from 'svelte-maplibre';
	import { getMapLayoutContext } from '../map-layout-context';

	const { mapController, itineraryStore } = getMapLayoutContext();

	const { itinerary } = itineraryStore;

	let itineraryCoordinates: Coordinates[] = $state([]);
	async function getCoordinates(waypoints: WayPoint[]) {
		const coordinates = await Promise.all(waypoints.map(getWaypointCoordinates));

		itineraryCoordinates = coordinates.filter(filterUndefined);
		fitItineraryPreviewOnMap(itineraryCoordinates);
	}

	watch(() => $itinerary, () => {
		getCoordinates($itinerary);
	});

	const geometry: LineString = $derived({
		type: 'LineString',
		coordinates: itineraryCoordinates.map(coordinates => [coordinates.lng, coordinates.lat]),
	});

	function fitItineraryPreviewOnMap(coordinates: Coordinates[]) {
		if (browser && $isMobile) {
			return;
		}

		// Fit the map to the itinerary
		// Only if there is at least 2 coordinates
		// Otherwise the map will zoom on the first point
		if (coordinates.length > 1) {
			$mapController.fitCoordinates(
				coordinates.map(coordinates => [coordinates.lng, coordinates.lat]),
			);
		}
	}
</script>

{#if geometry.coordinates.length >= 2}
	<GeoJSON data={geometry}>
		<LineLayer
			layout={{ 'line-cap': 'round', 'line-join': 'round' }}
			paint={{
				'line-width': 2,
				'line-dasharray': [2, 2],
				'line-color': '#27509B',
			}}
		/>
	</GeoJSON>
{/if}
